import styled from '@emotion/styled';
import { Text } from '@/components/atoms/Text';
import { Title } from '@/components/atoms/Title';

export const IMAGE_WIDTH = 800;
export const IMAGE_HEIGHT = 400;

export const CarrouselContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    max-width: 90vw;
    width: 100%;
    border-radius: 8px;
    font-family: ${({ theme }): string => theme.font.family};
`;

export const CloseButton = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    margin: ${({ theme }) => theme.spacing[2]};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.color.grey200};
    width: 36px;
    height: 36px;
    border-radius: 50%;
`;

export const BackgroundContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    > img {
        width: ${IMAGE_WIDTH}px;
        height: ${IMAGE_HEIGHT}px;
        max-height: 300px;
        object-fit: contain;
        background-color: ${({ theme }) => theme.color.white100};
        border-radius: 8px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
`;

export const ArrowContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.color.grey200};
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin: ${({ theme }) => theme.spacing[2]};
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    cursor: pointer;

    &:first-of-type {
        left: 0px;
    }

    &:last-of-type {
        right: 0px;
    }
`;

export const DescriptionContainer = styled.div`
    background-color: ${({ theme }) => theme.color.slate100};
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    color: ${({ theme }) => theme.color.white100};
    padding: ${({ theme }) => theme.spacing[6]};
    padding-bottom: ${({ theme }) => theme.spacing[10]};
    min-height: 200px;
    line-height: 1.5;
`;

export const TitleStyle = styled(Title)`
    color: ${({ theme }) => theme.color.white100};
    margin-bottom: ${({ theme }) => theme.spacing[2]};
`;

export const TextStyle = styled(Text)`
    color: ${({ theme }) => theme.color.white100};
`;

export const StepperContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${({ theme }) => theme.spacing[4]};
    gap: ${({ theme }) => theme.spacing[3]};
`;

export const StepperItem = styled.div<{ isActive: boolean }>`
    width: 38px;
    height: 8px;
    border-radius: 8px;
    background-color: ${({ theme, isActive }) => (isActive ? theme.color.white100 : theme.color.slate100)};
`;
